export default "__VITE_ASSET__5ec46b9e__"